export default "__VITE_ASSET__ebbd174a__"